(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Obtener la referencia al elemento donde mostraremos el plan seleccionado
  const selectedPlanElement = document.querySelector('.js-selected-plan');

  // Función para actualizar el plan seleccionado
  function updateSelectedPlan() {
    const selectedPlanInput = document.querySelector('input[name="plan-option"]:checked');
    if (selectedPlanInput && selectedPlanElement) {
      selectedPlanElement.textContent = selectedPlanInput.value;
    }
  }

  // Escuchar cambios en los radio buttons de plan
  const planInputs = document.querySelectorAll('input[name="plan-option"]');
  planInputs.forEach(input => {
    input.addEventListener('change', updateSelectedPlan);
  });

  // Actualizar el plan inicial
  updateSelectedPlan();

  // También escuchar el evento variant:changed por si acaso
  document.addEventListener('variant:changed', function(event) {
    updateSelectedPlan();
  });
});

  } catch(e) { console.error(e); }
})();
})();
